export const createVocabularyForTypes = (types, value) =>
  types.map(key => ({ [key]: value })).reduce((result, current) => ({ ...result, ...current }));



// WEBPACK FOOTER //
// ./src/shared/helpers/api.js